export default function setCheckedRadio(elementList, parent) {
  elementList.forEach((element, i) => {
    element.addEventListener('change', () => {
      elementList.forEach(e => {
        e.closest(parent).classList.toggle('o-productofferservice__item--checked', e.checked);
        const elementsToHide = document.querySelectorAll(`.js-offer-${e.value}`);
        if (elementsToHide.length > 0) {
          elementsToHide.forEach(element => {
            element.classList.toggle('mu-visually-hidden', !e.checked);
            const haveAttributeAriaHidden = element.getAttribute('aria-hidden');
            if (haveAttributeAriaHidden) {
              element.setAttribute('aria-hidden', `${!e.checked}`);
            }
          });
        }
      });
    });
  });
  window.onbeforeunload = function () {
    elementList.forEach((element, i) => {
      element.checked = !(i >= 1);
    });
  };
}